import { getFileExtension } from '@common/utils/fileNameHelpers';
import { excelFileExtensions, excelMimeTypes } from '../../fileUpload/constants';
import errorsFactory from '../../../utils/errorsFactory';
import { VALIDATION_ERRORS } from '../constants';

const excelFileTypeValidator = file => {
  const fileExtension = `.${getFileExtension(file.name).toLowerCase()}`;

  if (!excelMimeTypes.includes(file.type) && !excelFileExtensions.includes(fileExtension)) {
    throw errorsFactory.ValidationError(VALIDATION_ERRORS.NOT_EXCEL_FILE());
  }
};

export default excelFileTypeValidator;
